import axios from 'axios';
import axiosCancel from 'axios-cancel';
import {cacheAdapterEnhancer, throttleAdapterEnhancer} from 'axios-extensions';
import ReLogin from '@/api/relogin';
import {setAuthToken} from '@/utils/auth';
import store from '@/state/store';
import router from '@/router';
import {AUTH_COOKIE} from '@/state/modules/auth';

let AuthorizationTry = false;

const AuthorizationTryDone = () => new Promise(resolve => {
  const AuthorizationTryDoneInterval = setInterval(() => {
    if (AuthorizationTry) return;
    clearInterval(AuthorizationTryDoneInterval);
    resolve(true);
  }, 50);
});

axios.defaults.baseURL = process.env.VUE_APP_API_HOST || '/';

axios.defaults.adapter = cacheAdapterEnhancer(axios.defaults.adapter, {enabledByDefault: false})
axios.defaults.adapter = throttleAdapterEnhancer(axios.defaults.adapter, {threshold: 2 * 1000})

setAuthToken(window.localStorage.getItem(AUTH_COOKIE))

axiosCancel(axios, {debug: true});

axios.interceptors.request.use(config => {
  //console.info('axios BEFORE SEND | config = ', config)
  return config;
});

axios.interceptors.response.use(
  response => {
    if (response && response.data && response.data.error === 'one time password is required') {
      throw 'MESSAGGIO_OTP';
    }
    return response;
  },
  async error => {
    //console.info('window.axios.interceptors.response | error = ', error.toString());
    if (error.response && error.response.status) {
      console.error('window.axios.interceptors.response | error.response.status = ', error.response.status, ' | config = ', error.config);
    }
    if (axios.isCancel(error)) return Promise.reject(error);
    if (!error.response) return Promise.reject(error);
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          if (AuthorizationTry) await AuthorizationTryDone();
          AuthorizationTry = true;
          return new Promise(async (resolve, reject) => {
            try {
              if (!error.config.AuthorizationTry || error.config.AuthorizationTry < 2) {
                const result = await new ReLogin().run();
                if (result.success) {
                  const config = {...error.config};
                  config.headers['Authorization'] = axios.defaults.headers.common['Authorization'];

                  AuthorizationTry = false;

                  if (!config.AuthorizationTry) {
                    config.AuthorizationTry = 1;
                  } else {
                    config.AuthorizationTry += 1;
                  }
                  //console.info('window.axios.interceptors.response | config = ', config);
                  const requestNew = await axios.request(config);
                  //console.info('window.axios.interceptors.response | requestNew = ', requestNew);
                  return resolve(requestNew);
                }
              }
            } catch (e) {
              console.error('error.response.status 401 | error = ', e)
            }
            store.dispatch('auth/logOut');
            router.push('/login');
            return reject(error);
          });
        default:
          return Promise.reject(error);
      }
    }
  },
);
